import { isViewingLaborBirthTab } from './openLaborChartFocus';

export function buildOpenLaborChartLocation(item) {
  const clientReferenceId = String(item?.clientReferenceId || '').trim();
  const pregnancyReferenceId = String(item?.pregnancyReferenceId || '').trim();
  const laborEpisodeReferenceId = String(item?.laborEpisodeReferenceId || '').trim();
  if (!clientReferenceId || !pregnancyReferenceId || !laborEpisodeReferenceId) return null;

  return {
    pathname: `/charting/${encodeURIComponent(clientReferenceId)}`,
    search: `?pregnancy=${encodeURIComponent(pregnancyReferenceId)}&laborEpisode=${encodeURIComponent(laborEpisodeReferenceId)}&tab=birth`,
    state: { activeTab: 'birth', birthEventReferenceId: laborEpisodeReferenceId },
  };
}

export function readLaborChartRoute(location) {
  const match = location?.pathname?.match(/^\/charting\/([^/]+)\/?$/);
  if (!match) return null;
  let clientReferenceId;
  try { clientReferenceId = decodeURIComponent(match[1]); } catch { return { clientReferenceId: null }; }
  const query = new URLSearchParams(location.search);
  return {
    clientReferenceId,
    pregnancyReferenceId: query.get('pregnancy'),
    laborEpisodeReferenceId: query.get('laborEpisode') || location.state?.birthEventReferenceId,
  };
}

export function routeScopedLaborItems(location, items) {
  const route = readLaborChartRoute(location);
  if (!route) return items;
  // A selected episode remains the return destination even while the global
  // open-labor query is stale, loading, or omits this chart.
  if (route.clientReferenceId && route.pregnancyReferenceId && route.laborEpisodeReferenceId) return [route];
  return items.filter(item => item.clientReferenceId === route.clientReferenceId
    && (!route.pregnancyReferenceId || item.pregnancyReferenceId === route.pregnancyReferenceId));
}

export function shouldHideBackToLaborButton({
  items,
  isLoading,
  isError,
  isFetching,
  chartFocus,
}) {
  if (isLoading || isFetching || isError) return true;
  if (!Array.isArray(items) || items.length === 0) return true;

  if (items.length === 1 && isViewingLaborBirthTab(chartFocus, items[0])) {
    return true;
  }

  return false;
}
